export default {
  // Allgemein
  common: {
    back: 'Zurück',
    confirm: 'Bestätigen',
    continue: 'Weiter',
    cancel: 'Abbrechen',
    retry: 'Wiederholen',
    total: 'Gesamt',
    profile: 'Profil',
    history: 'Verlauf',
    pleaseLogin: 'Bitte anmelden',
    my: 'Mein Konto',
    appName: 'KI-Menü',
    loading: 'Lädt...',
    lang: "Sprache wählen",
    loadFailed: 'Laden fehlgeschlagen',
    operationFailed: 'Vorgang fehlgeschlagen',
    notSet: 'Nicht festgelegt',
    country: 'Land',
    all: 'Alle',
    searchPlaceholder: 'Platzhalter suchen',
    noMore: 'Keine weiteren Einträge'
  },

  // Startseite
  home: {
    allFoods: 'Alle Gerichte',
    headline: {
      sub: 'Entdecke',
      main: 'Küche aus {country}'
    },
    articleTag: 'Guide',
    localGuideTitle: 'Lokaler Guide',
    recommendedArticlesAll: 'Alle',
    hotTopics: 'Beliebte Themen',
    orderCallout: 'Nie wieder mit "this, this" bestellen!',
    mustEatBadge: 'Must-Eat',
    countrySelect: {
      eyebrow: 'Reiseziel',
      title: 'Land wählen',
      subtitle: 'Passende kulinarische Inspirationen und Guides für dich',
      footer: 'Du kannst dies jederzeit oben links ändern'
    },
    loadCountriesFailed: 'Laden der Länder fehlgeschlagen'
  },

  // Favoriten
  favorites: {
    title: 'Favoriten',
    empty: 'Noch keine Favoriten',
    foods: 'Gerichte',
    articles: 'Artikel'
  },

  articleList: {
    title: 'Guides für {country}',
    empty: 'Noch keine empfohlenen Guides'
  },

  // Gerichte-Details
  dishDetail: {
    quantity: 'Menge',
    introduction: 'Beschreibung',
    loadingIntroduction: 'Beschreibung wird geladen...',
    getIntroduction: 'Beschreibung anzeigen',
    addToCart: 'In den Warenkorb ({count})',
    selectQuantity: 'Menge wählen',
    addedToCart: '{count} zum Warenkorb hinzugefügt',
    loadFailed: 'Beschreibung konnte nicht geladen werden',
    noImage: 'Kein Bild verfügbar',
    imageSearchEmpty: 'Kein passendes Gerichtbild gefunden',
    imageSearchAction: 'Bilder suchen',
    aiImageGenerating: 'KI generiert Bild',
    generating: 'Wird erstellt...'
  },

  // Tab-Leiste
  tabbar: {
    home: 'Start',
    cameraOrder: 'Foto & Bestellen',
    favorites: 'Favoriten',
    profile: 'Ich',
    camera: 'Scan',
    menu: 'Menü'
  },

  // Kamera
  camera: {
    translate: 'Übersetzen in',
    takeOrUpload: 'Foto aufnehmen oder hochladen',
    uploadHint: 'Bis zu 9 Fotos möglich',
    addMore: 'Mehr hinzufügen',
    order: 'Bestellung starten',
    selectLanguage: 'Zielsprache wählen',
    singleMode: 'Einzelmodus',
    multiMode: 'Multimodus',
    history: 'Verlauf',
    takePhotoError: 'Aufnahme fehlgeschlagen, bitte erneut versuchen',
    cameraUnsupported: 'Kamera nicht unterstützt',
    cameraPermissionDenied: 'Kamerazugriff verweigert. Bitte in den Einstellungen aktivieren',
    capture: 'Weiter fotografieren',
    tapToCapture: 'Tippen zum Aufnehmen',
    tapToStart: 'Tippen zum Starten',
    readyToCapture: 'Menü fotografieren',
    uploading: 'Wird hochgeladen...',
    uploadFailed: 'Upload fehlgeschlagen',
    pleaseCapture: 'Bitte zuerst ein Foto machen',
    maxPhotosReached: 'Maximal 9 Fotos erreicht',
    photosAdded: '{count} Fotos hinzugefügt',
    confirmUpload: 'Hochladen',
    uploadMessage: '{count} Fotos werden zur Analyse hochgeladen',
    startRecognition: 'Analyse starten',
    confirmRecognition: 'Analyse bestätigen',
    willRecognize: '{count} Menüfotos werden analysiert',
    continueShooting: 'Weiter fotografieren',
    prepareUpload: 'Vorbereiten...',
    compressingImage: 'Bild wird komprimiert...',
    compressionFailed: 'Komprimierung fehlgeschlagen',
    useOriginal: 'Original verwenden',
    takePhoto: 'Foto aufnehmen',
    selectFromGallery: 'Aus Galerie wählen',
    operationFailed: 'Vorgang fehlgeschlagen, bitte erneut versuchen',
    processingPhoto: 'Foto wird verarbeitet...',
    leavingPageWarning: 'Fotos werden verarbeitet. Möchtest du die Seite wirklich verlassen?',
    restoreInfoMissing: 'Infos zu {count} früheren Fotos gefunden, aber Bilddaten fehlen. Bitte neu aufnehmen',
    addedAndSkipped: '{added} hinzugefügt, {skipped} ungültige Dateien übersprungen',
    remainingQuotaNotice: 'Lieber Nutzer {phone}: Gültigkeit des Abonnements: {days}',
    guide: {
      step1: 'Fotografieren',
      step2: 'KI-Analyse',
      step3: 'Menü erstellen'
    }
  },

  // Login
  login: {
    title: 'Anmelden',
    phone: 'Handy',
    code: 'Code',
    phoneNumber: 'Handynummer',
    verifyCode: 'Bestätigungscode',
    sendCode: 'Code senden',
    resend: 'Erneut senden',
    login: 'Anmelden',
    loggingIn: 'Anmeldung...',
    success: 'Erfolgreich',
    failed: 'Anmeldung fehlgeschlagen, bitte später versuchen',
    loginSuccess: 'Angemeldet',
    loginFailed: 'Anmeldung fehlgeschlagen',
    phonePlaceholder: 'Deine Handynummer',
    codePlaceholder: 'Code eingeben',
    phoneRequired: 'Handynummer erforderlich',
    codeRequired: 'Code erforderlich',
    phoneInvalid: 'Ungültige Nummer',
    codeInvalid: 'Code muss 4-6 Ziffern haben',
    phoneError: 'Nummer überprüfen',
    codeError: 'Code ungültig',
    codeSent: 'Code gesendet',
    resendCode: 'Erneut senden',
    countdown: 'Warten {count}s',
    retryAfter: 'Erneut in {seconds}s',
    tooFrequent: 'Bitte warten Sie einen Moment',
    dailyLimit: 'Tageslimit erreicht',
    sendFailed: 'Senden fehlgeschlagen',
    agreeTips: 'Mit der Anmeldung akzeptierst du unsere AGB und Datenschutzrichtlinien'
  },

  // Menü
  menu: {
    title: 'Menü',
    cartTitle: 'Warenkorb',
    checkout: 'Bestellen',
    totalItems: '{count} Artikel',
    clearCart: 'Leeren',
    emptyCart: 'Warenkorb ist leer',
    aiRecommend: 'KI-Tipps',
    addToCart: 'Hinzufügen',
    viewDetail: 'Details',
    price: 'Preis',
    quantity: 'Menge',
    currentMenu: 'Aktuelles Menü',
    clearCartConfirm: 'Warenkorb wirklich leeren?',
    noMenuData: 'Bitte zuerst Menü scannen',
    confirmButton: 'Ja',
    cancelButton: 'Nein',
    hint: 'Hinweis',
    noMenuItemsFound: 'Keine Menüpunkte erkannt'
  },

  // KI
  ai: {
    recommendedSets: 'Empfohlene Sets',
    dishCount: 'Gerichte',
    selectSetHint: 'Wähle ein Set',
    noSelectedDishes: 'Bitte zuerst Gerichte wählen',
    setPrefix: 'Set',
    others: 'Andere',
    diningOptions: 'Präferenzen',
    numberOfPeople: 'Personen',
    dietaryPreferences: 'Ernährung',
    budgetRange: 'Budget',
    getRecommendation: 'KI-Empfehlung',
    noSpicy: 'Nicht scharf',
    vegetarian: 'Vegetarisch',
    seafood: 'Meeresfrüchte',
    meat: 'Fleisch',
    loading: 'Empfehlungen werden erstellt...',
    recommendationTitle: 'KI empfiehlt',
    tastePreference: 'Geschmack',
    budgetPerPerson: 'Budget pro Person',
    allergyWarning: 'Allergien & Unverträglichkeiten',
    sweet: 'Süß',
    sour: 'Sauer',
    spicy: 'Scharf',
    bitter: 'Bitter',
    umami: 'Umami',
    light: 'Leicht',
    heavy: 'Deftig',
    dairy: 'Milchprodukte',
    eggs: 'Eier',
    fish: 'Fisch',
    shellfish: 'Schalentiere',
    treeNuts: 'Schalenfrüchte',
    peanuts: 'Erdnüsse',
    wheat: 'Weizen',
    soy: 'Soja',
    selectOptions: 'Deine Präferenzen',
    peopleCountError: 'Mindestens 1 Person',
    budgetRangeError: 'Budget muss positiv sein',
    budgetMaxMinError: 'Maximales Budget muss größer/gleich minimalem sein',
    submitFailed: 'Fehler beim Senden',
    minBudget: 'Min',
    maxBudget: 'Max',
    to: 'bis',
    yuan: '¥',
    recommendProgress: 'Fortschritt',
    analyzing: 'Analysiere Menü...',
    generating: 'Erstelle Vorschläge...',
    recommendReason: 'Warum empfohlen',
    menuCombination: 'Dein Menü',
    dietaryNotes: 'Ernährungshinweise',
    servingSize: 'Portionsgröße',
    viewDetail: 'Details',
    goToCheckout: 'Bestellen',
    dish: 'Portion(en)',
    menuOption: 'Option',
    recommendedDishes: 'Empfohlene Gerichte',
    categoryDishes: 'Nach Kategorie',
    order: 'Bestellen',
    orderConversation: 'Bestelldialog'
  },

  // Upload
  upload: {
    title: 'Analyse',
    uploading: 'Hochladen...',
    recognizing: 'Lese Menü...',
    translating: 'Übersetze...',
    generating: 'Erstelle Ergebnis...',
    complete: 'Fertig',
    failed: 'Fehler',
    progress: 'Fortschritt',
    detailsTitle: 'Analyse-Details',
    retake: 'Neu aufnehmen',
    retryUpload: 'Erneut versuchen',
    buyBenefits: 'Vorteile upgraden',
    uploadingNow: 'Lade hoch',
    aiRecognizingImages: 'KI liest Bilder',
    aiTranslatingMenu: 'KI übersetzt Menü',
    dynamicCompression: 'Dynamische Bildkomprimierung',
    ocrEngineIntegration: 'OCR-Engine Integration',
    agentEngineBoot: 'Agent-Engine Start',
    llmContextParsing: 'LLM Kontext-Analyse',
    ragTargetLanguage: 'RAG Zielsprachen-Abgleich',
    cuisineRegionMapping: 'Küche & Region Mapping',
    enhancedTranslation: 'Erweiterte Übersetzung',
    dishMetadataClassification: 'Gericht-Metadaten Klassifizierung',
    semanticUiConstruction: 'Semantischer UI-Aufbau',
    confirmCancelTitle: 'Abbrechen?',
    confirmCancelMessage: 'Analyse wirklich abbrechen?',
    preparingCount: 'Bereite {count} Fotos vor...',
    startUploadCount: 'Lade {count} Fotos hoch',
    processingComplete: 'Verarbeitung abgeschlossen',
    navigatingSoon: 'Leite weiter...',
    processingCompleteAndNavigate: 'Fertig, leite weiter...',
    createBackgroundTask: 'Starte Hintergrundprozess...',
    noPhotoFound: 'Keine Fotos gefunden',
    pleaseRetake: 'Bitte neu aufnehmen',
    dataParseFailed: 'Datenverarbeitung fehlgeschlagen',
    photoDataParseFailed: 'Bilddaten fehlerhaft',
    photoDataFormatError: 'Formatfehler, bitte neu aufnehmen',
    uploadFailedShort: 'Fehlgeschlagen',
    failedShort: 'Fehler',
    errorTryAgain: 'Bitte erneut versuchen',
    menuNotFound: 'Kein Menü erkannt, bitte neu aufnehmen',
    otherLlmErr: 'Übersetzung fehlgeschlagen',
    finalizing: 'Finalisiere Übersetzung',
    almostDone: 'Fast fertig, bitte warten'
  },

  // Fehler
  error: {
    network: 'Netzwerkfehler, Verbindung prüfen',
    server: 'Serverfehler, bitte später versuchen',
    timeout: 'Zeitüberschreitung, bitte erneut versuchen',
    unknown: 'Unbekannter Fehler',
    auth: 'Sitzung abgelaufen, bitte neu anmelden',
    selectImage: 'Bitte Bild wählen',
    imageTooLarge: 'Bild zu groß (max 20MB)',
    processPhotoFailed: 'Verarbeitung fehlgeschlagen',
    processFileFailed: 'Dateifehler',
    pageStateError: 'Seitenfehler, bitte neu aufnehmen',
    processingPhotos: 'Verarbeite Fotos...',
    livePhotoNotSupported: 'Live Photos nicht unterstützt',
    microphonePermissionDenied: 'Mikrofonzugriff verweigert',
    microphoneNotFound: 'Kein Mikrofon gefunden',
    microphoneInUse: 'Mikrofon wird bereits verwendet',
    microphoneConfigNotSupported: 'Audio-Konfiguration nicht unterstützt',
    recordingNotSupported: 'Browser unterstützt keine Aufnahme',
    recordingError: 'Aufnahmefehler',
    forbidden: 'Keine Berechtigung',
    notFound: 'Nicht gefunden',
    requestFailed: 'Anfrage fehlgeschlagen',
    configError: 'Konfigurationsfehler'
  },

  // Bestelldialog
  orderConversation: {
    title: 'Gespräch mit Kellner',
    menu_order: 'Bestellen',
    quantity: 'Menge',
    translatedText: 'Übersetzung',
    orderText: 'Bestelltext',
    userSpeak: 'Halten zum Sprechen',
    waiterSpeak: 'Halten zum Sprechen',
    customerSpeak: 'Halten zum Sprechen',
    waiterSpec: 'Kellner',
    customerSpec: 'Gast',
    dish_detail: 'Details',
    recording: 'Höre zu...',
    common_confirm: 'OK',
    customerRecording: 'Gast spricht...',
    recognizing: 'Erkenne...',
    translating: 'Übersetze...',
    recordingFailed: 'Aufnahme fehlgeschlagen',
    recognitionFailed: 'Nicht verstanden',
    translationFailed: 'Übersetzungsfehler',
    recognitionResult: 'Erkannt',
    blankAudio: 'Nachricht zu kurz',
    noDishes: 'Keine Gerichte gewählt',
    assistantIntro: 'Hallo, ich bin der digitale Bestellassistent. Der Gast möchte Folgendes bestellen. Tippen Sie, um die Nachricht zu hören, oder halten Sie die Taste gedrückt, um zu antworten – ich werde übersetzen.'
  },

  // Profil
  profile: {
    title: 'Mein Profil',
    memberCard: {
      title: 'Mitgliedschaft',
      dynamicTitle: 'Du bist aktuell {status}-Nutzer und genießt folgende Vorteile:',
      feature1: ' Präzise Menüerkennung',
      feature2: ' Übersetzung in 20+ Sprachen',
      feature3: ' KI-Empfehlungen',
      feature4: ' Internationale Kücheninfos',
      feature5: ' Kontinuierliche Sprachübersetzung',
      featureUsageTemplate: '{feature} ({count})',
      unlock: 'Jetzt freischalten',
      unlockBenefits: 'Vorteile upgraden'
    },
    menu: {
      privacy: 'Datenschutz',
      terms: 'AGB',
      feedback: 'Feedback',
      serviceStatus: 'Dienststatus',
      about: 'Über uns'
    },
    redeem: {
      button: 'Gutschein einlösen',
      title: 'Gutschein einlösen',
      description: 'Gib deinen 12-stelligen Code ein, um Vorteile zu aktivieren.',
      placeholder: 'Code eingeben',
      helper: 'Buchstaben A-Z und Ziffern 0-9. Leerzeichen werden ignoriert, Groß-/Kleinschreibung ist egal.',
      submit: 'Einlösen',
      cancel: 'Abbrechen',
      success: 'Eingelöst. Deine Vorteile wurden aktualisiert.',
      validation: {
        empty: 'Bitte Code eingeben.',
        length: 'Code muss 12 Zeichen lang sein und Buchstaben sowie Zahlen enthalten.',
        format: 'Code-Format ungültig.',
        checksum: 'Prüfung fehlgeschlagen. Bitte Code überprüfen.'
      }
    },
    register: 'Konto löschen',
    registerHint: 'Demnächst verfügbar',
    logout: 'Abmelden',
    logoutConfirm: {
      title: 'Abmelden',
      message: 'Möchtest du dich wirklich abmelden?'
    },
    logoutSuccess: 'Abgemeldet'
  },

  subscription: {
    subtitle: 'AI MENU PASS',
    title: 'Schalte smarte Vorteile frei',
    columns: {
      feature: 'Enthalten'
    },
    plans: {
      freeUser: 'Kostenloser Nutzer',
      trial: 'Kostenlose Testphase',
      trialTag: 'Zeitlich begrenzt',
      oneDay: '1-Tages-Pass',
      twoDay: '2-Tages-Pass',
      threeDay: '3-Tages-Pass',
      fiveDay: '5-Tages-Pass'
    },
    actions: {
      tryNow: 'Jetzt testen',
      purchase: 'Jetzt kaufen',
      continueTrial: 'Testen fortsetzen',
      trialUnavailable: 'Testphase beendet',
      renew: 'Jetzt verlängern',
      subscribed: 'Aktiv'
    },
    features: {
      validity: 'Restgültigkeit',
      price: 'Preis',
      usageCount: 'Nutzungen',
      aiTranslate: 'KI-Menü-Scan & Übersetzung (20+ Sprachen)',
      aiTextDetail: 'KI-Gerichtbeschreibungen',
      aiRichDetail: 'KI-Storys zu Gerichten (Text & Bild)',
      aiRecommend: 'Lokale KI-Empfehlungen',
      aiOrder: 'KI-Bestellassistent',
      aiVoice: 'Sprachübersetzung'
    },
    values: {
      days: '{count} Tage',
      lifetime: 'Lebenslang',
      free: '0',
      price: '¥{amount} CNY',
      times: '{count}x',
      notAvailable: '-',
      comingSoon: '- (demnächst)'
    },
    remarkTitle: 'Hinweise',
    remarksText:
      '1. Menü-Scan verfügbar in: Asien - Japan, Südkorea, Thailand, Vietnam, Singapur, Malaysia, Indonesien, VAE, Türkei; Europa - UK, Frankreich, Deutschland, Österreich, Schweiz, Italien, Irland, Spanien, Portugal, Russland, Tschechien, Ungarn, Kroatien, Niederlande, Rumänien, Schweden; Nordamerika - USA, Kanada, Mexiko; Südamerika - Brasilien, Argentinien, Chile, Uruguay, Paraguay, Kolumbien, Venezuela, Panama, Peru, Ecuador; Sonstige - Australien, Neuseeland.' +
      '\nHinweis: Schweiz unterstützt Deutsch, Französisch, Italienisch; Österreich nur Deutsch; Südamerika (außer Brasilien) Spanisch.' +
      '\n2. Inhalte und Regeln können aktualisiert werden. Die endgültige Auslegung erfolgt im Einklang mit den Gesetzen zum Schutz Ihrer Rechte.',
    toast: {
      trialRedirect: 'Leite zur Aktivierung weiter...',
      purchaseRedirect: 'Leite zum Kauf weiter...',
      contactAdmin: 'Bitte Administrator kontaktieren.',
      noQuota: 'Keine Nutzungen mehr übrig. Bitte Paket kaufen.',
      subscriptionExpired: 'Abo abgelaufen oder aufgebraucht. Bitte verlängern.',
      trialExhausted: 'Testphase beendet. Bitte Abo kaufen.',
      wechatRequired: 'Bitte in WeChat öffnen für Zahlung.',
      paySuccess: 'Zahlung erfolgreich. Vorteile aktualisiert.',
      payCancelled: 'Zahlung abgebrochen.',
      payFailed: 'Zahlung fehlgeschlagen. Bitte später versuchen.',
      payPending: 'Die Zahlung wird bestätigt. Prüfe den Bestellstatus später.',
      productUnavailable: 'Produkt derzeit nicht verfügbar.'
    },
    currentBenefits: 'Aktuelle Vorteile',
    moreDetails: 'Mehr Details',
    remainingBenefits: 'Verbleibend',
    totalBenefits: 'Gesamt',
    expireTime: 'Ablaufdatum',
    tabs: {
      compare: 'Vergleich',
      detail: 'Details'
    },
    upgradeTitle: 'Upgrade dein Abo',
    trialNoteTitle: 'Test-Info',
    trialNoteText: 'Testnutzer können die Menü-Übersetzung und weitere Funktionen ausprobieren. Die Testphase beeinflusst die Abonnementvorteile nicht.',
    statusDetail: {
      title: 'Paketdetails',
      planName: 'Paketname',
      startTime: 'Startdatum',
      expireTime: 'Ablaufdatum',
      totalCount: 'Gesamt',
      status: 'Status',
      statusMap: {
        pending: 'Ausstehend',
        active: 'Aktiv',
        invalid: 'Ungültig/Abgelaufen'
      }
    },
    durations: {
      oneDay: '1 Tag',
      twoDay: '2 Tage',
      threeDay: '3 Tage',
      fiveDay: '5 Tage'
    },
    subscriptionSuffix: 'Abo',
    subscriptionName: '{duration}-Abo',
    fiveDayDesc: '5 Tage gültig',
    validityOnly: '{duration} gültig',
    validityAndUsage: '{duration} gültig, enthält {usage} Nutzungen',
    usageCountSimple: 'Nutzungen'
  }
}
